import { TableColumn } from "@/components/Table/Table";
import { TItem } from "@/components/SortableList/SortableList";

/**
 * Serialises table columns into the persisted column-config shape (order + visibility). Extracted
 * from `UnassignedTable` so the reset/migration paths share one definition.
 */
export const buildTableConfigItems = (columns: TableColumn[]): TItem[] =>
	columns.map((c, index) => ({
		uid: c.uid ?? "",
		id: index + 1,
		show: typeof c.show !== "undefined" ? c.show : true,
		content: c.title,
		svgIcon: c.svgIcon?.toString(),
		locked: !!c.locked || false,
		allowExclude: typeof c.allowExclude !== "undefined" ? c.allowExclude : true,
		custom: c.uid?.includes("custom-") || false,
		columnId: c.uid?.includes("custom-") ? +c.uid.split("-")[1] : undefined,
		moveable: c.moveable,
		hideable: c.hideable,
	}));
